import { SimpleBars } from '../../../Common/Charts/SimpleBars';
import { useFetalDeathChartsDataContext } from './hooks/useFetalDeathChartsDataContext';

export const MotherAge = () => {
    const { chartData } = useFetalDeathChartsDataContext();


    return (
        <SimpleBars
            title={'Idade da mãe'}
            horizontal={true}
            subtitles={chartData?.motherAge?.map((item) => item.description)}
            values={chartData?.motherAge?.map((item) => item.total  ||  0)}
        />
    );
};
